export default __webpack_public_path__ + "static/media/bd-exec-5.a5d25380.jpg";